import React, { Component } from 'react'
import DOMPurify from 'dompurify';
import { Route } from 'react-router-dom'
import moment from 'moment'


export default class Footer extends Component {
  constructor(props) {    
    super(props)
  }

  extraLandingDirections() {
    const todayDate = moment()
    return (
      <div className="extra-landing-footer">
        <hr className="line-break"/>
        <p className="extra-footer-info">© {todayDate.format('YYYY')} NEWTOPIA INC. </p>
        <p className="extra-footer-info">The Newtopia program requires you to complete a personal profile. There is a question in the profile that asks about your family medical history (the family medical history question is marked as "voluntary" in the profile). Completion of this question, as well as providing a genetic (saliva) test sample, is strictly voluntary. If you choose to provide family medical history in the personal profile or provide a genetic (saliva) test sample, your authorization to process the genetic (saliva) test sample and/or analyze your family medical history is included in the Newtopia Genetics Consent Agreement that you will be asked to agree to on the following screen. That Agreement also describes confidentiality protections and restrictions on the use and disclosure of your genetic information.</p>
      </div>
    )
  } 

  joinSocial() {
    return (
      <div className="intro-join">
        <a className="intro-social" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">
          <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/699eac18-91fd-4ab6-ab43-f79ff6e2666f.png?b=1518544011000" alt="facebook" />
        </a>
        <a className="intro-social" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">
          <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/909f7323-4473-4d5a-aae1-42761aa02735.png?b=1518544011000" alt="instagram" />
        </a>
        <br/>
        <span className="join-text-footer">
          Follow us on <a className="social-word-link" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">Facebook</a> and <a className="social-word-link" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">Instagram</a>  to get tips on how to improve your nutrition, exercise, and well-being.
        </span>  
      </div>
    )
  }

  lineBreak() {
    return <hr className="footer-separator" />
  }

  render() {
    const joinSocial = this.joinSocial()
    let purifiedHTML = null
    let clientCareText = "Contact Client Care at"
    let officeHoursText = "Office Hours:"
    if (this.props.contactInfoCustomText != null) {
      purifiedHTML = DOMPurify.sanitize(this.props.contactInfoCustomText);
      clientCareText = "Contact Newtopia Client Care at"
      officeHoursText = "Newtopia Office Hours:"
    }
    return (
      <div>
        <div className="footer">
          <Route path={`/(register|questionnaire|welcome|profile|coaching)`} component={this.lineBreak} />
          <div className="contacts">
            <div id="contacts" name="contacts" className="anchor-link" />
            <h2 className="title">Have any questions? We are standing by to support you.</h2>
            <p><div dangerouslySetInnerHTML={{ __html: purifiedHTML}}/></p>
            {this.props.contactInfoCustomText != null && <hr className="line-break-custom" />}
            <p>
              {clientCareText}&nbsp;
              <a href="tel:+18886398181">
                1-888-639-8181
              </a>
              &nbsp;or&nbsp;
              <a href="mailto:clientcare@newtopia.com">
                clientcare@newtopia.com
              </a>
            </p>
            <div className="hours">
              <div className="paragraph hours">{officeHoursText}</div>
              <div className="paragraph hours">8 am - 8 pm EST Monday</div>
              <div className="paragraph hours">8 am - 10 pm EST Tuesday - Thursday</div>
              <div className="paragraph hours">8 am - 6 pm EST Friday</div>
              <div className="paragraph hours">10 am - 2 pm EST Saturday</div>
            </div>
            {joinSocial}
          </div>
        </div>
        <Route path={`/landing`} component={this.extraLandingDirections} />
      </div>
    )
  }
}